import { AffiliateLink, Statistics, Table, WithdrawFunds } from "./components";
import style from "./ReferralNetworkPage.module.scss";

export function ReferralNetworkPage() {
    return (
        <main className={style.page}>
            <p className={style.pageName}>Реферальна програма</p>
            <div className={style.flexBox}>
                <AffiliateLink />
                <Statistics />
            </div>
            <WithdrawFunds />
        </main>
    )
}